import { render } from "./Subscribe.vue?vue&type=template&id=66534a3e&scoped=true&ts=true"
import script from "./Subscribe.vue?vue&type=script&lang=ts"
export * from "./Subscribe.vue?vue&type=script&lang=ts"

import "./Subscribe.vue?vue&type=style&index=0&id=66534a3e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Edson\\Desktop\\work\\STUDOS PROD\\studiostvapp\\PlatformStudiosApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66534a3e"]])

export default __exports__